

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import Helpers from '../../helpers/helper';
import { HogarSuspension } from '../../models/hogar/alertas.model';
@Component
export default class HogarSuspensionesTable extends GenericBTable<
  HogarSuspension
> {
  @Prop() public title!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public hogarId!: string;
  created() {
    this.setupTable();
  }
  setupTable() {
    this.tableConfig.controller = this.controller || "hogarsuspension";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    //this.tableConfig.resource = "alertas";
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    if (this.hogarId) result.push(`hogarId="${this.hogarId}"`);
    return result.join("&");
  }
  formatColumns() {
    let razon = new BTableColumn("razon", "Razón");
    let subsidio = new BTableColumn("subsidio", "Subsidio");
    let mes = new BTableColumn("mes", "Mes");
    mes.type = BTableColumnType.Custom;
    mes.customFilter = (value:string) => Helpers.Filters.NumAMes(value);
    let ano = new BTableColumn("ano", "Año");
    let fecha = new BTableColumn("fecha", "Fecha");
    fecha.type = BTableColumnType.Date;
    this.tableConfig.insertColumns(razon, subsidio, mes,ano, fecha);
  }
  @Watch("hogarId", { immediate: true })
  onhogarIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
